var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-devx content-dx-upload-file"},[_c('f7-block',{staticClass:"profile"},[_c('input',{ref:"inputFile",attrs:{"id":"upload","type":"file"},on:{"change":_vm.onFileSelected}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }